import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTopic from '../../../../components/newsTopic';
import ContentTitle from '../../../../components/contentTitle';
import NewsList from '../../../../components/newsList';
import ListTitle from '../../../../components/listTitle';

class TechBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { techTopic, techTitle0, techTitle1, techList0, techList1, techList2, techListAd },
        } = this.props;

        return (
            <div id="techNewsList" className={styles.tech_box}>
                <Chip id="50078" type="struct" title="科技凤眼栏标题" groupName="科技凤眼栏" content={techTopic}>
                    <NewsTopic />
                </Chip>
                <Chip
                    id="75099"
                    type="recommend"
                    title="科技凤眼栏头条1"
                    groupName="科技凤眼栏"
                    content={techTitle0}
                    translate="handleNewsContentData">
                    <ContentTitle />
                </Chip>
                <Chip
                    id="75100"
                    type="recommend"
                    title="科技凤眼栏新闻列表1"
                    groupName="科技凤眼栏"
                    content={techList0}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75101"
                    type="recommend"
                    title="科技凤眼栏头条2"
                    groupName="科技凤眼栏"
                    content={techTitle1}
                    translate="handleNewsBoxData">
                    <ListTitle />
                </Chip>
                <Chip
                    id="75102"
                    type="recommend"
                    title="科技凤眼栏新闻列表2"
                    groupName="科技凤眼栏"
                    content={techList1}
                    translate="handleNewsContentData">
                    <NewsList isList />
                </Chip>
                <Chip
                    id="75103"
                    type="recommend"
                    title="科技凤眼栏新闻列表3"
                    groupName="科技凤眼栏"
                    content={techList2}
                    translate="handleNewsContentData">
                    <NewsList isList ad={techListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(TechBox);
